export const GET_PRODUCT_LIST = 'GET_PRODUCT_LIST'
export const GET_PRODUCT_DETAILS = 'GET_PRODUCT_DETAILS'
export const GET_PRODUCT_VARIANT_INFO = 'GET_PRODUCT_VARIANT_INFO'
export const GET_PRODUCT_VARIANT_INFO_FULFILLED = 'GET_PRODUCT_VARIANT_INFO_FULFILLED'

export const GET_STORE_SETTINGS = 'GET_STORE_SETTINGS'

export const GET_PRODUCT_FORM = 'GET_PRODUCT_FORM'
